module.exports = __webpack_public_path__ + "static/nxrt-mainpage2-1be956aa97c03a61e8b632d329f61ae6.jpg";